export default "__VITE_ASSET__BPGrt9No__"